import { render, staticRenderFns } from "./UserTownList.vue?vue&type=template&id=1b5066c8&scoped=true"
import script from "./UserTownList.vue?vue&type=script&lang=js"
export * from "./UserTownList.vue?vue&type=script&lang=js"
import style0 from "./UserTownList.vue?vue&type=style&index=0&id=1b5066c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5066c8",
  null
  
)

export default component.exports